import { Link } from '@remix-run/react'
import { type useOptionalUser } from '#app/utils/user.js'
import { Button } from './ui/button'
import { Icon } from './ui/icon'

export function StaticHeader({
	user,
	position = 'absolute',
}: {
	user: ReturnType<typeof useOptionalUser>
	position: 'absolute' | 'relative'
}) {
	return (
		<header
			className={`${position} left-0 top-0 flex h-16 w-full items-center justify-between border-b border-b-border px-3`}
		>
			<nav className="flex w-full items-center justify-between gap-3">
				<Link to="/" className="ml-1 mr-3 block outline-offset-8 outline-ring">
					<img
						className="h-10 dark:hidden"
						src="/logos/kogia-logo-light-theme.png"
						alt="Kogia Logo"
					/>
					<img
						className="hidden h-10 dark:block"
						src="/logos/kogia-logo-dark-theme.png"
						alt="Kogia Logo"
					/>
				</Link>
				<div className="flex items-center gap-4">
					<Button asChild variant={'ghost'} size="default">
						<Link to="/">
							<Icon className="mr-2" name="magnifying-glass" size="md" />
							Library
						</Link>
					</Button>
					<Button asChild variant={'ghost'} size="default">
						<Link to="/studio">Studio</Link>
					</Button>
					<Button asChild variant={'ghost'} size="default">
						<Link to="/about">About</Link>
					</Button>
					<Button asChild variant={'ghost'} size="default">
						<Link to="/donate">Donate</Link>
					</Button>
					<Button asChild variant={'ghost'} size="default">
						<Link to="/apply">Apply</Link>
					</Button>
					{/* {user && (
						<Button asChild variant={'ghost'} size="default">
							<Link to="/">Go to app</Link>
						</Button>
					)} */}
					{!user && (
						<>
							<Button asChild variant={'ghost'} size="default">
								<Link to="/login">Login</Link>
							</Button>
							<Button asChild variant={'ghost'} size="default">
								{/* TODO: Fix link */}
								<Link to="/signup">Sign Up</Link>
							</Button>
						</>
					)}
				</div>
			</nav>
		</header>
	)
}
